import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'

type State = {} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.ADD_COMPLAINT_MISSING_ATTACHMENT_ASYNC,
    Actions.ADD_COMPLAINT_MISSING_ATTACHMENT_SUCCESS,
    Actions.ADD_COMPLAINT_MISSING_ATTACHMENT_FAIL
  >,
): State => {
  switch (action.type) {
    case Actions.ADD_COMPLAINT_MISSING_ATTACHMENT_ASYNC:
    case Actions.ADD_COMPLAINT_MISSING_ATTACHMENT_SUCCESS:
    case Actions.ADD_COMPLAINT_MISSING_ATTACHMENT_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
